
const user = {
    state: {
        token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
        userName: localStorage.getItem('userName') ? localStorage.getItem('userName') : '',
        routerPath: localStorage.getItem('routerPath'),
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_USERNAME: (state, name) => {
            state.userName = name
        },
        SET_ROUTERPATH: (state, data) => {
            state.routerPath = data
        },
    },

    actions: {
        // 保存token
        setToken({ commit }, data) {
            commit('SET_TOKEN', data)
        },
        // 保存用户名
        setUserName({ commit }, data) {
            commit('SET_USERNAME', data)
        },
        // 保存最后一次路由
        setRouterPath({ commit }, data) {
            commit('SET_ROUTERPATH', data)
        },
    }
}

export default user
